export function footerSpecialBar() {
    if (document.cookie.indexOf("footerBanner=") < 0) {
        document.body.classList.add("footer-popup-active");
    }
    function checkScroll() {
        let scrollTop = document.documentElement.scrollTop;
        let scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrollPercentage = (scrollTop / scrollHeight) * 100;


        if (scrollPercentage >= 30) {
            document.body.classList.add("show-footer-bar");
        } else {
            document.body.classList.remove("show-footer-bar");
        }
    }

    const closeBtn = document.querySelector(".footer-special-bar .close");
    closeBtn.addEventListener("click", () => {
        ClosePopup();
    });

    function ClosePopup() {
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (1000 * 60 * 60));
        document.cookie = "footerBanner=yes; path=/; expires=" + expiry.toGMTString();
        document.body.classList.remove("footer-popup-active");
    }

    window.addEventListener("scroll", checkScroll);
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerSpecialBar.js